import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import { AlarmsApiService } from './alarms-api.service';
import { DevicesPayload } from '../../devices/components/devices.models';
import { Alarm, Alarms, AlarmsRows, AlarmsTable } from './alarm-data.types';
import { mapLink } from '../../../../shared/constants';
import { AlarmGroupItem } from './alarms.types';
import { MapValidator } from '../../../../shared/components/listing-page/helpers/map-validator';
import { TimezoneService } from 'src/app/services/utility/timezone.service';

@Injectable({
  providedIn: 'root'
})
export class AlarmsService {
  private alarmsApiService = inject(AlarmsApiService);
  private timezoneService = inject(TimezoneService);

  prepareDataForTable(tableState: DevicesPayload): Observable<AlarmsTable> {
    const initState = { data: [], total: 0 };
    return this.alarmsApiService.getAlarms(tableState).pipe(
      map((alarms: Alarms) => {
        if (!alarms) return initState;

        const { items, totalCount } = alarms;
        const tableList = items?.map((alarm: Alarm) => ({
          ...alarm,
          dateTime: this.timezoneService.formatLong(alarm.dateTimeUtcUpdated),
          location: alarm.geoMetaData && MapValidator.isValidCoords(alarm.geoMetaData?.latitude) ? mapLink : null
        })) as AlarmsRows[];

        return { data: tableList, total: totalCount };
      }),
      catchError(() => of(initState))
    );
  }

  getAlarmGroupItems(): Observable<AlarmGroupItem[]> {
    return this.alarmsApiService.getAlarmGroups().pipe(
      map(response => response.items),
      catchError(() => of([]))
    );
  }
}
